export const spacing = {
  none: 0,
  xxs: 2,
  xs: 4,
  sm: 8,
  md: 12,
  lg: 16,
  xl: 24,
  xxl: 32,
  "3xl": 40,
  "4xl": 48,
  "5xl": 64,
} as const;

export type Spacing = typeof spacing;
